import Vue from "vue";
import VueMeta from "vue-meta";
import veevalidate from "vee-validate";
import VueToast from "vue-toast-notification";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import VueFormWizard from "vue-form-wizard";
import "vue-toast-notification/dist/theme-sugar.css";
//select/dropdown option vue componet
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import moment from "moment";
// import VModal from "vue-js-modal";
import CKEditor from "ckeditor4-vue";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
import V_Session from "v-session";
import { BootstrapVue } from "bootstrap-vue";
import "@/mixins/commonMixin";

var options = {
    unique: false,
    expire: 5,
    inactive: 3,
    encrypt: true,
    secret_key: "encrypt-session"
};
Vue.use(V_Session, options);

Vue.use(VueCroppie);

Vue.use(BootstrapVue);

Vue.use(VueMeta);
// import VueCardFormat from 'vue-credit-card-validation';
// Vue.use(VueCardFormat);

// Vue.use(VModal, {
//   dialog: true
// });

Vue.component("v-select", vSelect);

Vue.use(VueToast, { duration: 2500 });
Vue.use(VuejsDialog);
Vue.use(VueFormWizard);
Vue.use(CKEditor);

const config = {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: {
        /* eslint-disable */
        en: {
            messages: {
                confirmed: (field, params) =>
                    `Password and Confirm Password does not match`
            }
        }
        /* eslint-enable */
    },
    errorBagName: "errors", // change if property conflicts
    events: "input|blur",
    fieldsBagName: "fields",
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: "validations", // the nested key under which the validation messages will be located
    inject: true,
    locale: "en",
    validity: false,
    useConstraintAttrs: true
};

Vue.use(veevalidate, config);

import { VTooltip, VPopover, VClosePopover } from "v-tooltip";

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);

// Vue.use(VueToast);

// Vue Tags
import VueTagsInput from "@johmun/vue-tags-input";
Vue.component("VueTagsInput", VueTagsInput);

import App from "./App.vue";
import router from "./router";
import store from "./store";
//import "./registerServiceWorker";

let Header = "";
let Footer = "";

import { CHECK_AUTH, FETCH_ROLLUP_FEES } from "./store/actions.type";
import ApiService from "./common/api.service";
import DateFilter from "./common/date.filter";
import ErrorFilter from "./common/error.filter";
//####Import front-end header footer component//
import RwvHeader from "@/components/frontend/TheHeader";
import RwvFooter from "@/components/frontend/TheFooter";
import OrderProofReviewHeader from "@/views/frontend/account/OrderProofReviewHeader";

//## Added Js File
Header = RwvHeader;
Footer = RwvFooter;
Vue.component("OrderProofReviewHeader", OrderProofReviewHeader);
Vue.component("RwvHeader", Header);
Vue.component("RwvFooter", Footer);
Vue.config.productionTip = false;
Vue.filter("date", DateFilter);
Vue.filter("error", ErrorFilter);
Vue.filter("capitalize", function (value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

import ProductZoomer from "./components/vue-product-zoomer/src//components/ProductZoomer.vue";
Vue.component("ProductZoomer", ProductZoomer);

Vue.filter("converToCamel", function (value) {
    if (!value) return "";
    return value.replace(
        /(^\w|\s\w)(\S*)/g,
        (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
    );
});

Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("MMM DD, YYYY");
    }
});
Vue.filter("formatDateNow", function (value) {
    if (value) {
        return moment(String(value)).fromNow();
    }
});

import JwtService from "@/common/jwt.service";
ApiService.init();
// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
    // If Authentication Required
    if (to.meta.authRequired && !JwtService.getToken() && to.name !== "home") {
        Vue.$toast.error("Error: Please login to access this page", {
            position: "top-right"
        });
        next({ name: "home" });
    }
    // Updated Page title
    Vue.nextTick(() => {
        document.title = to.meta.title || to.meta.pageTitle || "ImprintCity";
    });

    if (JwtService.getToken()) {
        let getProfData = JwtService.getUserData();
        if(getProfData && getProfData !=undefined)
        {
            if(getProfData.user.status === 0)
            {
                Vue.$toast.error("Unauthorized: " , {
                    position: "top-right"
                });
                JwtService.destroyToken();
                next("/");
            }
        }
        if (getProfData) {
            Promise.all([store.dispatch(CHECK_AUTH)])
                .then(() => {
                    if (
                        to.name == "ResetPassword" &&
                        store.state.auth.isAuthenticatedClient
                    ) {
                        next("/");
                        return;
                    }
                    next();
                })
                .catch((error) => {
                    console.log("test", error);
                });

            let permission_data = JSON.parse(
                getProfData.user.RolePermission.permission_id
            );
            permission_data[5].submodule_json.forEach((element) => {
                if (to.meta.is_permission == element.name) {
                    if (!element.permissions.full) {
                        next({ path: "/no-access" });
                    }
                }
            });
        } else {
            ApiService.setHeader();
            ApiService.get("user-profile")
                .then(({ data }) => {
                    // Save UserData in Session
                    JwtService.saveUserData(data);
                    Promise.all([store.dispatch(CHECK_AUTH)])
                        .then(() => {
                            if (
                                to.name == "ResetPassword" &&
                                store.state.auth.isAuthenticatedClient
                            ) {
                                next("/");
                                return;
                            }
                            next();
                        })
                        .catch((error) => {
                            console.log("test", error);
                        });
                    let permission_data = JSON.parse(
                        data.user.RolePermission.permission_id
                    );
                    permission_data[5].submodule_json.forEach((element) => {
                        if (to.meta.is_permission == element.name) {
                            if (!element.permissions.full) {
                                next({ path: "/no-access" });
                            }
                        }
                    });
                })
                .catch(function (error) {
                    if (error.response) {
                        console.log(
                            error.response.data,
                            error.response.status,
                            error.response.headers
                        );
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        let errorMsg = error.message;
                        let status = errorMsg.search(/401/);
                        if (status > 0) {
                            Vue.$toast.error("Unauthorized: " + errorMsg, {
                                position: "top-right"
                            });
                            JwtService.destroyToken();
                        } else {
                            Vue.$toast.error("Error: " + errorMsg, {
                                position: "top-right"
                            });
                        }
                    }
                });
        }
        next();
    } else {
        next();
    }
});

// Initialize rollup fees on app load
store.dispatch(`rollupFees/${FETCH_ROLLUP_FEES}`).catch((error) => {
    console.error("Failed to fetch rollup fees:", error);
});

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount("#app");
